(function () {
	const elId = '#app-custom-client-menu';

	if ($(elId).length == 0) {
		return;
	}

	const app = new Vue({
		mixins: [window.vueMountedCreatedMixin],
		el: elId,
		data: {
			noLoader: true,
			items: []
		},
		created: function () {
			this.fetchData();
		},
		methods: {
			fetchData: function () {
				const self = this;
				const clientMenu = sessionStorage.getItem('nominow-client-menu-items');
				if (!clientMenu) {
					GET('/baas/nominow_clientmenu/menuitems?filter={IsActive:true}&sort={Sortorder:1}')
						.then(xhr => {
							const response = xhr.responseText;
							sessionStorage.setItem('nominow-client-menu-items', response);
							console.log(response);
							self.items = JSON.parse(response);
							if (self.items.length > 0) {
								$(self.$options.el).removeClass('is-hidden');
							}
						})
						.catch(xhr => {
							console.log('failed to load client menu items', xhr);
							sessionStorage.setItem('nominow-client-menu-items', '[]');
						});
				} else {
					self.items = JSON.parse(clientMenu);
					if (self.items.length > 0) {
						$(self.$options.el).removeClass('is-hidden');
					}
				}
			},
			isItemActive: function (item) {
				const current = unescape(document.location.pathname.substring(17));
				if (item.Name == current) {
					return 'is-active';
				}
				return null;
			}
		}
	});

	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeMenuComponent = app;
})();

(function () {
	const elId = '#app-client-menu-loader';

	if ($(elId).length == 0) {
		return;
	}

	const app = new Vue({
		mixins: [window.vueMountedCreatedMixin],
		el: elId,
		data: {
			component: null,
			currentComponent: null,

			modal: null,
			componentmodal: null
		},
		created: function () {
			toggleLoader(true);
			this.component = unescape(document.location.pathname.substring(17));
			document.title = `${this.component} - ${document.title}`;
			this.loadComponent();
		},
		methods: {
			loadComponent: function () {
				const self = this;
				const clientMenuList = JSON.parse(sessionStorage.getItem('nominow-client-menu-items'));
				if (clientMenuList) {
					const currentItem = Array.prototype.find.call(clientMenuList, item => item.Name == self.component);
					let compCode = currentItem.Component;
					const compCodeTemplate = currentItem.ComponentTemplate;

					compCode = compCode.replace('``', `\`${compCodeTemplate}\``);

					const newCompId = `component-${new Date().getTime()}`;
					const htmltest = `<script id="scriptfor-${newCompId}">Vue.component("${newCompId}", ${compCode});</script>`;
					$('body').append(htmltest);

					Vue.nextTick(() => {
						self.currentComponent = newCompId;
					});

					$(this.$options.el).removeClass('is-hidden');
				}
				toggleLoader(false);
			}
		}
	});

	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeMenuLoaderComponent = app;
})();
